(function () {
  function initWallpaperProduct() {
    var root = document.querySelector('[data-wallpaper-crop-root][data-section-type="product"]');
    if (!root) return;

    var form = root.querySelector('.product-form-leos');
    var workspace = root.querySelector('[data-crop-workspace]');
    var image = root.querySelector('#crop_image_main');
    var unitSelector = root.querySelector('[data-unit-selector]');
    var previewButton = root.querySelector('[data-open-crop]');
    var customSizeVisualizerButton = root.querySelector('.idealhouse-view-on-wall--custom');
    var closeButton = root.querySelector('[data-close-crop]');
    var overlay = root.querySelector('[data-crop-overlay]');
    var wallCanvas = root.querySelector('[data-wall-canvas]');
    var canvasCropBox = root.querySelector('[data-canvas-crop-box]');
    var panelLines = root.querySelector('[data-panel-lines]');
    var rulerTop = root.querySelector('[data-ruler-top]');
    var rulerLeft = root.querySelector('[data-ruler-left]');
    var personGuide = root.querySelector('[data-person-guide]');
    var widthLabel = root.querySelector('[data-width-label]');
    var heightLabel = root.querySelector('[data-height-label]');
    var sizePrompt = root.querySelector('[data-size-prompt]');
    var dragHint = root.querySelector('[data-drag-hint]');
    var dismissDragHint = root.querySelector('[data-dismiss-drag-hint]');
    var unitPicker = root.querySelector('[data-unit-picker]');
    var unitToggle = root.querySelector('[data-unit-toggle]');
    var unitMenu = root.querySelector('[data-unit-menu]');
    var unitCurrent = root.querySelector('[data-unit-current]');
    var priceNumber = root.querySelector('#prd_price');
    var comparePriceNumber = root.querySelector('#prd_compare_price');
    var comparePriceWrapper = root.querySelector('[data-compare-price]');
    var priceSummary = root.querySelector('.ever-price-summary');
    var priceSuffix = root.querySelector('.ever-price-summary small');
    var orderPrices = root.querySelectorAll('[data-order-price]');
    var addButton = root.querySelector('.cst_crop_buy');
    var addButtonPrice = addButton ? addButton.querySelector('[data-add-price]') : null;
    var addButtonDivider = addButton ? addButton.querySelector('[data-add-divider]') : null;
    var addButtonLabel = addButton ? addButton.querySelector('[data-add-label]') : null;
    var sizeRequiredLabel = addButton ? addButton.querySelector('[data-size-required-label]') : null;
    var cropDataInput = root.querySelector('#CropData');
    var currency = root.getAttribute('data-currency-symbol') || '£';
    var invalidSizeMessage = root.getAttribute('data-invalid-size') || 'Enter a valid wall width and height.';
    var uploadFailedMessage = root.getAttribute('data-upload-failed') || 'The cropped image could not be uploaded. Please try again.';
    var productHandle = root.getAttribute('data-product-handle') || 'custom-wallpaper';
    var sourceMode = root.getAttribute('data-crop-source-mode') || 'product';
    var uploadRequiredMessage = root.getAttribute('data-upload-required') || 'Upload an image before opening the wall preview.';
    var uploadInput = document.querySelector('[data-wallpaper-upload]');
    var uploadPreview = root.querySelector('[data-upload-preview]');
    var uploadPreviewFrame = root.querySelector('[data-upload-preview-frame]');
    var uploadPreviewCopy = root.querySelector('[data-upload-preview-copy]');
    var uploadedFile = null;
    var uploadedObjectUrl = '';
    var cropper = null;
    var cropOverlayFrame = 0;
    var canvasRenderFrame = 0;
    var resizeFrame = 0;
    var lockedCanvasLeft = 0;
    var lockedCanvasTop = 0;
    var movementAxis = 'horizontal';
    var canvasDrag = null;
    var canvasDragBound = false;
    var state = {
      unit: unitSelector ? unitSelector.value : 'cm',
      widthCm: 0,
      heightCm: 0,
      quantity: 0,
      mirrored: false,
      grayscale: false,
      savedCrop: null,
      sourceReady: sourceMode !== 'upload',
      pageScroll: 0
    };

    function createCanvasCropper() {
      var cropHost = root.querySelector('.croper_main_image');
      var context = wallCanvas ? wallCanvas.getContext('2d') : null;
      var cropBoxData = { left: 0, top: 0, width: 0, height: 0 };
      var canvasData = { left: 0, top: 0, width: 0, height: 0 };
      var destroyed = false;

      function copyData(data) {
        return { left: data.left, top: data.top, width: data.width, height: data.height };
      }

      function syncCropBox() {
        if (!canvasCropBox) return;
        canvasCropBox.style.left = cropBoxData.left + 'px';
        canvasCropBox.style.top = cropBoxData.top + 'px';
        canvasCropBox.style.width = cropBoxData.width + 'px';
        canvasCropBox.style.height = cropBoxData.height + 'px';
      }

      function drawArtwork(drawContext, left, top, width, height, mirrored) {
        if (!mirrored) {
          drawContext.drawImage(image, left, top, width, height);
          return;
        }
        drawContext.save();
        drawContext.translate(left + width, top);
        drawContext.scale(-1, 1);
        drawContext.drawImage(image, 0, 0, width, height);
        drawContext.restore();
      }

      function drawImageLayer(drawContext, offsetX, offsetY, scaleX, scaleY, preview) {
        if (!canvasData.width || !canvasData.height || !image.complete) return;
        drawContext.save();
        drawContext.imageSmoothingEnabled = true;
        drawContext.imageSmoothingQuality = 'high';
        if (preview && state.grayscale) drawContext.filter = 'grayscale(1)';
        drawArtwork(
          drawContext,
          offsetX + canvasData.left * scaleX,
          offsetY + canvasData.top * scaleY,
          canvasData.width * scaleX,
          canvasData.height * scaleY,
          state.mirrored
        );
        drawContext.restore();
      }

      function gradientColour(alpha) {
        return 'rgba(244,244,241,' + alpha + ')';
      }

      function drawGradientMask(drawContext, hostWidth, hostHeight) {
        var dragging = cropHost.classList.contains('is-dragging-artwork');
        var margin = hostWidth < 576 ? 15 : 50;
        var startAlpha = dragging ? 224 / 255 : 240 / 255;
        var endAlpha = dragging ? 74 / 255 : 176 / 255;
        if (movementAxis === 'vertical') {
          var verticalFadeLength = margin * (dragging ? 2.5 : 1);
          var cropBottom = cropBoxData.top + cropBoxData.height;
          var verticalGradient = drawContext.createLinearGradient(0, 0, 0, hostHeight);
          var topOuter = Math.max(0, (cropBoxData.top - verticalFadeLength) / hostHeight);
          var topInner = Math.max(0, cropBoxData.top / hostHeight);
          var bottomInner = Math.min(1, cropBottom / hostHeight);
          var bottomOuter = Math.min(1, (cropBottom + verticalFadeLength) / hostHeight);
          verticalGradient.addColorStop(0, gradientColour(1));
          verticalGradient.addColorStop(topOuter, gradientColour(startAlpha));
          verticalGradient.addColorStop(topInner, gradientColour(endAlpha));
          verticalGradient.addColorStop(bottomInner, gradientColour(endAlpha));
          verticalGradient.addColorStop(bottomOuter, gradientColour(startAlpha));
          verticalGradient.addColorStop(1, gradientColour(1));
          drawContext.fillStyle = verticalGradient;
          drawContext.fillRect(cropBoxData.left, 0, cropBoxData.width, cropBoxData.top);
          drawContext.fillRect(cropBoxData.left, cropBottom, cropBoxData.width, Math.max(0, hostHeight - cropBottom));
          return;
        }
        var fadeLength = margin * 4 * (dragging ? 2.5 : 1);
        var cropRight = cropBoxData.left + cropBoxData.width;
        var gradient = drawContext.createLinearGradient(0, 0, hostWidth, 0);
        var leftOuter = Math.max(0, (cropBoxData.left - fadeLength) / hostWidth);
        var leftInner = Math.max(0, cropBoxData.left / hostWidth);
        var rightInner = Math.min(1, cropRight / hostWidth);
        var rightOuter = Math.min(1, (cropRight + fadeLength) / hostWidth);
        gradient.addColorStop(0, gradientColour(1));
        gradient.addColorStop(leftOuter, gradientColour(startAlpha));
        gradient.addColorStop(leftInner, gradientColour(endAlpha));
        gradient.addColorStop(rightInner, gradientColour(endAlpha));
        gradient.addColorStop(rightOuter, gradientColour(startAlpha));
        gradient.addColorStop(1, gradientColour(1));
        drawContext.fillStyle = gradient;
        drawContext.fillRect(0, cropBoxData.top, cropBoxData.left, cropBoxData.height);
        drawContext.fillRect(cropRight, cropBoxData.top, Math.max(0, hostWidth - cropRight), cropBoxData.height);
      }

      function renderNow() {
        canvasRenderFrame = 0;
        if (destroyed || !wallCanvas || !context || !cropHost) return;
        var hostWidth = cropHost.clientWidth;
        var hostHeight = cropHost.clientHeight;
        if (!hostWidth || !hostHeight) return;
        var resolution = Math.max(2, (window.devicePixelRatio || 1) * 2);
        var pixelWidth = Math.round(hostWidth * resolution);
        var pixelHeight = Math.round(hostHeight * resolution);
        if (wallCanvas.width !== pixelWidth || wallCanvas.height !== pixelHeight) {
          wallCanvas.width = pixelWidth;
          wallCanvas.height = pixelHeight;
        }
        wallCanvas.style.width = hostWidth + 'px';
        wallCanvas.style.height = hostHeight + 'px';
        context.setTransform(resolution, 0, 0, resolution, 0, 0);
        context.clearRect(0, 0, hostWidth, hostHeight);
        context.fillStyle = '#f4f4f1';
        context.fillRect(0, 0, hostWidth, hostHeight);
        drawImageLayer(context, 0, 0, 1, 1, true);
        drawGradientMask(context, hostWidth, hostHeight);
        cropHost.dataset.imageLeft = String(canvasData.left);
        cropHost.dataset.imageTop = String(canvasData.top);
        cropHost.dataset.dragAxis = movementAxis;
      }

      function render() {
        if (canvasRenderFrame) cancelAnimationFrame(canvasRenderFrame);
        canvasRenderFrame = requestAnimationFrame(renderNow);
      }

      function setCanvasData(data) {
        ['left', 'top', 'width', 'height'].forEach(function (key) {
          if (Number.isFinite(data[key])) canvasData[key] = data[key];
        });
        render();
      }

      function setCropBoxData(data) {
        ['left', 'top', 'width', 'height'].forEach(function (key) {
          if (Number.isFinite(data[key])) cropBoxData[key] = data[key];
        });
        syncCropBox();
        scheduleOverlayPosition();
        render();
      }

      function getData() {
        var scale = image.naturalWidth ? canvasData.width / image.naturalWidth : 1;
        return {
          x: (cropBoxData.left - canvasData.left) / Math.max(scale, 0.0001),
          y: (cropBoxData.top - canvasData.top) / Math.max(scale, 0.0001),
          width: cropBoxData.width / Math.max(scale, 0.0001),
          height: cropBoxData.height / Math.max(scale, 0.0001)
        };
      }

      function setData(data) {
        var scale = image.naturalWidth ? canvasData.width / image.naturalWidth : 1;
        if (Number.isFinite(data.x)) canvasData.left = clampCanvasLeft(cropBoxData.left - data.x * scale);
        if (Number.isFinite(data.y)) canvasData.top = clampCanvasTop(cropBoxData.top - data.y * scale);
        if (movementAxis === 'horizontal') canvasData.top = lockedCanvasTop;
        else canvasData.left = lockedCanvasLeft;
        render();
      }

      function getCroppedCanvas(options) {
        var output = document.createElement('canvas');
        output.width = Math.max(1, Math.round(options.width));
        output.height = Math.max(1, Math.round(options.height));
        var outputContext = output.getContext('2d');
        outputContext.fillStyle = options.fillColor || '#ffffff';
        outputContext.fillRect(0, 0, output.width, output.height);
        var scaleX = output.width / Math.max(1, cropBoxData.width);
        var scaleY = output.height / Math.max(1, cropBoxData.height);
        drawImageLayer(outputContext, -cropBoxData.left * scaleX, -cropBoxData.top * scaleY, scaleX, scaleY, false);
        return output;
      }

      return {
        destroy: function () {
          destroyed = true;
          if (canvasRenderFrame) cancelAnimationFrame(canvasRenderFrame);
          canvasRenderFrame = 0;
          if (context && wallCanvas) context.clearRect(0, 0, wallCanvas.width, wallCanvas.height);
        },
        getCanvasData: function () { return copyData(canvasData); },
        getCropBoxData: function () { return copyData(cropBoxData); },
        getImageData: function () { return { naturalWidth: image.naturalWidth, naturalHeight: image.naturalHeight }; },
        getData: getData,
        getCroppedCanvas: getCroppedCanvas,
        move: function (x, y) { canvasData.left += x || 0; canvasData.top += y || 0; render(); },
        render: render,
        reset: function () { render(); },
        scaleX: function () { render(); },
        setAspectRatio: function () {},
        setCanvasData: setCanvasData,
        setCropBoxData: setCropBoxData,
        setData: setData
      };
    }

    function numberValue(selector) {
      var input = root.querySelector(selector);
      var value = input ? parseFloat(input.value) : 0;
      return Number.isFinite(value) ? value : 0;
    }

    function rounded(value, places) {
      var factor = Math.pow(10, places || 0);
      return Math.round(value * factor) / factor;
    }

    function displayNumber(value) {
      return rounded(value, 1).toLocaleString('en-GB', { maximumFractionDigits: 1 });
    }

    function displayExactRulerNumber(value, maximumFractionDigits) {
      return value.toLocaleString('en-GB', {
        useGrouping: false,
        maximumFractionDigits: maximumFractionDigits
      });
    }

    function readMeasurements() {
      if (state.unit === 'cm') {
        state.widthCm = numberValue('.cm_width');
        state.heightCm = numberValue('.cm_height');
      } else if (state.unit === 'inches') {
        state.widthCm = numberValue('.in_width') * 2.54;
        state.heightCm = numberValue('.in_height') * 2.54;
      } else {
        var widthInches = numberValue('.ft_width') * 12 + Math.min(numberValue('.inf_width'), 11);
        var heightInches = numberValue('.ft_height') * 12 + Math.min(numberValue('.inf_height'), 11);
        state.widthCm = widthInches * 2.54;
        state.heightCm = heightInches * 2.54;
      }
      state.quantity = isValidSize() ? Math.max(1, Math.ceil((state.widthCm * state.heightCm) / 10000)) : 0;
    }

    function isValidSize() {
      return state.widthCm > 0 && state.heightCm > 0 && Number.isFinite(state.widthCm) && Number.isFinite(state.heightCm);
    }

    function workspaceAspectRatio() {
      if (isValidSize()) return state.widthCm / state.heightCm;
      if (image && image.naturalWidth && image.naturalHeight) return image.naturalWidth / image.naturalHeight;
      return 1.5;
    }

    function selectedVariant() {
      return root.querySelector('.action-set.selected-variant');
    }

    function variantPriceCents() {
      var variant = selectedVariant();
      var cents = variant ? parseInt(variant.getAttribute('data-price'), 10) : 0;
      if (!Number.isFinite(cents) || cents <= 0) {
        var basePrice = root.querySelector('.base_price');
        cents = basePrice ? parseInt(basePrice.getAttribute('data-price'), 10) : 0;
      }
      return Number.isFinite(cents) ? cents : 0;
    }

    function variantCompareAtPriceCents() {
      var variant = selectedVariant();
      var cents = variant ? parseInt(variant.getAttribute('data-compare-at-price'), 10) : 0;
      if (!Number.isFinite(cents) || cents <= 0) {
        var basePrice = root.querySelector('.base_price');
        cents = basePrice ? parseInt(basePrice.getAttribute('data-compare-at-price'), 10) : 0;
      }
      return Number.isFinite(cents) ? cents : 0;
    }

    function money(cents) {
      return currency + (cents / 100).toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function syncVisualizerButton() {
      var integration = window.EverIdealhouseRoomVisualizer;
      var imageCrop = cropper && integration
        ? integration.normalizeImageCrop(
          cropper.getData(true),
          cropper.getImageData(),
          { flipX: state.mirrored, grayscale: state.grayscale }
        )
        : undefined;
      if (integration) {
        integration.syncCustomSizeButton(customSizeVisualizerButton, {
          width: rounded(state.widthCm, 2),
          height: rounded(state.heightCm, 2),
          unit: 'cm'
        }, imageCrop);
      }
    }

    function updatePrice() {
      var hasSize = isValidSize();
      var cents = variantPriceCents();
      var compareAtCents = variantCompareAtPriceCents();
      var total = hasSize ? cents * state.quantity : cents;
      var compareAtTotal = hasSize ? compareAtCents * state.quantity : compareAtCents;
      var onSale = compareAtTotal > total;
      if (priceNumber) {
        priceNumber.textContent = (total / 100).toLocaleString('en-GB', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      if (comparePriceNumber) {
        comparePriceNumber.textContent = (compareAtTotal / 100).toLocaleString('en-GB', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      if (comparePriceWrapper) comparePriceWrapper.hidden = !onSale;
      if (priceSummary) priceSummary.classList.toggle('is-on-sale', onSale);
      if (priceSuffix) priceSuffix.hidden = hasSize;
      orderPrices.forEach(function (orderPrice) { orderPrice.textContent = money(total); });
      if (previewButton) previewButton.disabled = !state.sourceReady;
      if (addButton) addButton.disabled = !hasSize || !cropper;
      if (addButtonPrice) addButtonPrice.hidden = !hasSize;
      if (addButtonDivider) addButtonDivider.hidden = !hasSize;
      if (addButtonLabel) addButtonLabel.hidden = !hasSize;
      if (sizeRequiredLabel) sizeRequiredLabel.hidden = hasSize;
      var sizes = root.querySelector('.sizes-container');
      if (sizes) sizes.setAttribute('data-price', state.quantity || '');

      syncVisualizerButton();
    }

    function measurementText() {
      if (state.unit === 'cm') {
        return {
          width: displayNumber(numberValue('.cm_width')) + ' cm',
          height: displayNumber(numberValue('.cm_height')) + ' cm'
        };
      }
      if (state.unit === 'inches') {
        return {
          width: displayNumber(numberValue('.in_width')) + ' in',
          height: displayNumber(numberValue('.in_height')) + ' in'
        };
      }
      return {
        width: displayNumber(numberValue('.ft_width')) + ' ft ' + displayNumber(numberValue('.inf_width')) + ' in',
        height: displayNumber(numberValue('.ft_height')) + ' ft ' + displayNumber(numberValue('.inf_height')) + ' in'
      };
    }

    function setFeetInputs(prefix, centimetres) {
      var totalInches = centimetres / 2.54;
      var feet = Math.floor(totalInches / 12);
      var inches = Math.round(totalInches - feet * 12);
      if (inches === 12) {
        feet += 1;
        inches = 0;
      }
      root.querySelector('.ft_' + prefix).value = feet;
      root.querySelector('.inf_' + prefix).value = inches;
    }

    function populateUnitFromCentimetres(unit) {
      if (!isValidSize()) return;
      if (unit === 'cm') {
        root.querySelector('.cm_width').value = rounded(state.widthCm, 1);
        root.querySelector('.cm_height').value = rounded(state.heightCm, 1);
      } else if (unit === 'inches') {
        root.querySelector('.in_width').value = rounded(state.widthCm / 2.54, 1);
        root.querySelector('.in_height').value = rounded(state.heightCm / 2.54, 1);
      } else {
        setFeetInputs('width', state.widthCm);
        setFeetInputs('height', state.heightCm);
      }
    }

    function setUnit(unit) {
      root.querySelectorAll('[data-measurement-panel]').forEach(function (panel) {
        var active = panel.getAttribute('data-measurement-panel') === unit;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        panel.querySelectorAll('input').forEach(function (input) {
          input.disabled = !active;
        });
      });
      state.unit = unit;
      if (unitSelector) unitSelector.value = unit;
      if (unitCurrent) unitCurrent.textContent = unit === 'inches' ? 'in' : unit === 'ft' ? 'ft/in' : 'cm';
      root.querySelectorAll('[data-unit-option]').forEach(function (option) {
        option.setAttribute('aria-selected', option.getAttribute('data-unit-option') === unit ? 'true' : 'false');
      });
      readMeasurements();
      updatePrice();
      updateGuides();
    }

    function panelDetails() {
      var count = isValidSize() ? Math.max(1, Math.ceil(state.widthCm / 50)) : 0;
      var lastWidth = count ? state.widthCm - (count - 1) * 50 : 0;
      return { count: count, lastWidth: rounded(lastWidth, 1) };
    }

    function buildPanelGuides() {
      if (!panelLines || !isValidSize()) return;
      panelLines.innerHTML = '';
      for (var position = 50; position < state.widthCm; position += 50) {
        var line = document.createElement('span');
        line.style.left = position / state.widthCm * 100 + '%';
        panelLines.appendChild(line);
      }
    }

    function addRulerMark(axis, position, maximum, label, rank, endpoint) {
      if (!axis || maximum <= 0) return;
      var mark = document.createElement('span');
      mark.className = 'ever-ruler-mark';
      if (rank === 3) mark.classList.add('is-major');
      else if (rank === 2) mark.classList.add('is-half');
      else if (rank === 1) mark.classList.add('is-quarter');
      if (endpoint) mark.classList.add('is-endpoint');
      if (axis === rulerTop) mark.style.left = position / maximum * 100 + '%';
      else mark.style.bottom = position / maximum * 100 + '%';
      if ((rank === 3 || endpoint) && label) {
        var text = document.createElement('b');
        text.textContent = label;
        mark.appendChild(text);
      }
      axis.appendChild(mark);
    }

    function buildRulers() {
      if (!rulerTop || !rulerLeft || !isValidSize()) return;
      rulerTop.innerHTML = '';
      rulerLeft.innerHTML = '';
      var widthMax = state.unit === 'cm' ? state.widthCm : state.widthCm / 2.54;
      var heightMax = state.unit === 'cm' ? state.heightCm : state.heightCm / 2.54;
      var minorStep = state.unit === 'cm' ? 10 : 1;
      var majorStep = state.unit === 'cm' ? 100 : 12;
      var makeLabel = function (value) {
        if (state.unit === 'cm') return displayNumber(value / 100) + 'm';
        if (state.unit === 'ft') return displayNumber(value / 12) + 'ft';
        return displayNumber(value) + 'in';
      };
      var makeEndpointLabel = function (value) {
        if (state.unit === 'cm') return displayExactRulerNumber(value / 100, 4) + 'm';
        if (state.unit === 'inches') return displayExactRulerNumber(value, 4) + 'in';
        var totalInches = Math.round(value);
        var feet = Math.floor(totalInches / 12);
        var inches = totalInches - feet * 12;
        return feet + 'ft' + (inches ? ' ' + inches + 'in' : '');
      };
      var markRank = function (value) {
        if (Math.abs(value % majorStep) < 0.001) return 3;
        if (state.unit !== 'cm') {
          var inch = Math.round(value) % 12;
          if (inch === 6) return 2;
          if (inch === 3 || inch === 9) return 1;
        }
        return 0;
      };
      for (var x = 0; x <= widthMax + 0.001; x += minorStep) {
        var xRank = markRank(x);
        addRulerMark(rulerTop, x, widthMax, xRank === 3 ? makeLabel(x) : '', xRank, false);
      }
      for (var y = 0; y <= heightMax + 0.001; y += minorStep) {
        var yRank = markRank(y);
        addRulerMark(rulerLeft, y, heightMax, yRank === 3 ? makeLabel(y) : '', yRank, false);
      }
      if (Math.abs(widthMax % majorStep) > 0.001) addRulerMark(rulerTop, widthMax, widthMax, makeEndpointLabel(widthMax), 3, true);
      if (Math.abs(heightMax % majorStep) > 0.001) addRulerMark(rulerLeft, heightMax, heightMax, makeEndpointLabel(heightMax), 3, true);
    }

    function updateGuides() {
      if (!overlay) return;
      var hasSize = isValidSize();
      overlay.classList.toggle('is-size-pending', !hasSize);
      if (sizePrompt) sizePrompt.hidden = hasSize;
      if (!hasSize) {
        if (widthLabel) widthLabel.hidden = true;
        if (heightLabel) heightLabel.hidden = true;
        if (panelLines) panelLines.innerHTML = '';
        if (rulerTop) rulerTop.innerHTML = '';
        if (rulerLeft) rulerLeft.innerHTML = '';
        scheduleOverlayPosition();
        return;
      }
      if (widthLabel) widthLabel.hidden = false;
      if (heightLabel) heightLabel.hidden = false;
      var text = measurementText();
      if (widthLabel) widthLabel.textContent = text.width;
      if (heightLabel) heightLabel.textContent = text.height;
      if (personGuide) {
        var personHeight = 165 / state.heightCm * 100;
        personGuide.style.setProperty('--person-height', personHeight + '%');
      }
      buildPanelGuides();
      buildRulers();
      scheduleOverlayPosition();
    }

    function positionOverlay() {
      cropOverlayFrame = 0;
      if (!overlay || !cropper) return;
      var cropBox = root.querySelector('.cropper-crop-box');
      var cropHost = root.querySelector('.croper_main_image');
      if (!cropBox || !cropHost) return;
      var box = cropBox.getBoundingClientRect();
      var host = cropHost.getBoundingClientRect();
      overlay.style.left = box.left - host.left + 'px';
      overlay.style.top = box.top - host.top + 'px';
      overlay.style.width = box.width + 'px';
      overlay.style.height = box.height + 'px';
    }

    function scheduleOverlayPosition() {
      if (cropOverlayFrame) cancelAnimationFrame(cropOverlayFrame);
      cropOverlayFrame = requestAnimationFrame(positionOverlay);
    }

    function focusOnFocalPoint() {
      if (!cropper || !image) return;
      var x = Math.min(100, Math.max(0, parseFloat(image.getAttribute('data-focal-x')) || 50)) / 100;
      var y = Math.min(100, Math.max(0, parseFloat(image.getAttribute('data-focal-y')) || 50)) / 100;
      var cropBox = cropper.getCropBoxData();
      var canvas = cropper.getCanvasData();
      var imageData = cropper.getImageData();
      if (!imageData.naturalWidth || !imageData.naturalHeight) return;
      var pointX = canvas.left + x * canvas.width;
      var pointY = canvas.top + y * canvas.height;
      cropper.move(
        movementAxis === 'horizontal' ? cropBox.left + cropBox.width / 2 - pointX : 0,
        movementAxis === 'vertical' ? cropBox.top + cropBox.height / 2 - pointY : 0
      );
      moveCanvas(cropper.getCanvasData().left, cropper.getCanvasData().top);
    }

    function clampCanvasLeft(left) {
      if (!cropper) return left;
      var cropBox = cropper.getCropBoxData();
      var canvas = cropper.getCanvasData();
      var minimum = cropBox.left + cropBox.width - canvas.width;
      var maximum = cropBox.left;
      return Math.max(minimum, Math.min(maximum, left));
    }

    function clampCanvasTop(top) {
      if (!cropper) return top;
      var cropBox = cropper.getCropBoxData();
      var canvas = cropper.getCanvasData();
      var minimum = cropBox.top + cropBox.height - canvas.height;
      var maximum = cropBox.top;
      return Math.max(minimum, Math.min(maximum, top));
    }

    function moveCanvas(left, top) {
      if (!cropper) return;
      cropper.setCanvasData({
        left: movementAxis === 'horizontal' ? clampCanvasLeft(left) : lockedCanvasLeft,
        top: movementAxis === 'vertical' ? clampCanvasTop(top) : lockedCanvasTop
      });
      scheduleOverlayPosition();
    }

    function finishCanvasDrag(event, cropHost) {
      if (!canvasDrag || event.pointerId !== canvasDrag.pointerId) return;
      if (cropHost.hasPointerCapture && cropHost.hasPointerCapture(event.pointerId)) cropHost.releasePointerCapture(event.pointerId);
      canvasDrag = null;
      cropHost.classList.remove('is-dragging-artwork');
      if (cropper) cropper.render();
      captureCropState();
    }

    function prepareCanvasCropInteraction() {
      var cropHost = root.querySelector('.croper_main_image');
      var cropBoxElement = root.querySelector('.cropper-crop-box');
      if (!cropHost || !cropBoxElement) return;
      cropBoxElement.removeAttribute('tabindex');
      cropBoxElement.removeAttribute('aria-label');
      cropHost.setAttribute('tabindex', '0');
      cropHost.setAttribute('data-drag-axis', movementAxis);
      cropHost.setAttribute('aria-label', movementAxis === 'horizontal' ? 'Move image left or right' : 'Move image up or down');
      if (canvasDragBound) return;
      canvasDragBound = true;
      cropHost.addEventListener('pointerdown', function (event) {
        var interactiveTarget = event.target.closest && event.target.closest('button, a, input, select, textarea, [role="button"], [contenteditable="true"]');
        if (!cropper || interactiveTarget || event.button !== 0 || event.isPrimary === false) return;
        var canvas = cropper.getCanvasData();
        canvasDrag = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          canvasLeft: canvas.left,
          canvasTop: canvas.top,
          axis: movementAxis
        };
        cropHost.classList.add('is-dragging-artwork');
        cropper.render();
        if (cropHost.setPointerCapture) cropHost.setPointerCapture(event.pointerId);
        event.preventDefault();
      });
      cropHost.addEventListener('pointermove', function (event) {
        if (!canvasDrag || event.pointerId !== canvasDrag.pointerId) return;
        moveCanvas(
          canvasDrag.canvasLeft + (canvasDrag.axis === 'horizontal' ? event.clientX - canvasDrag.startX : 0),
          canvasDrag.canvasTop + (canvasDrag.axis === 'vertical' ? event.clientY - canvasDrag.startY : 0)
        );
        event.preventDefault();
      });
      cropHost.addEventListener('pointerup', function (event) { finishCanvasDrag(event, cropHost); });
      cropHost.addEventListener('pointercancel', function (event) { finishCanvasDrag(event, cropHost); });
      cropHost.addEventListener('lostpointercapture', function (event) {
        if (!canvasDrag || event.pointerId !== canvasDrag.pointerId) return;
        canvasDrag = null;
        cropHost.classList.remove('is-dragging-artwork');
        if (cropper) cropper.render();
        captureCropState();
      });
      cropHost.addEventListener('keydown', function (event) {
        var horizontalKey = event.key === 'ArrowLeft' || event.key === 'ArrowRight';
        var verticalKey = event.key === 'ArrowUp' || event.key === 'ArrowDown';
        if (!cropper || event.target !== cropHost || (movementAxis === 'horizontal' ? !horizontalKey : !verticalKey)) return;
        var step = event.shiftKey ? 20 : 4;
        var canvas = cropper.getCanvasData();
        moveCanvas(
          canvas.left + (movementAxis === 'horizontal' ? (event.key === 'ArrowLeft' ? -step : step) : 0),
          canvas.top + (movementAxis === 'vertical' ? (event.key === 'ArrowUp' ? -step : step) : 0)
        );
        captureCropState();
        event.preventDefault();
      });
    }

    function fitWorkspaceGeometry() {
      if (!cropper) return;
      var cropHost = root.querySelector('.croper_main_image');
      var imageData = cropper.getImageData();
      if (!cropHost || !imageData.naturalWidth || !imageData.naturalHeight) return;
      var hostWidth = cropHost.clientWidth;
      var hostHeight = cropHost.clientHeight;
      var margin = hostWidth < 576 ? 15 : 50;
      var availableWidth = Math.max(1, hostWidth - margin * 2);
      var availableHeight = Math.max(1, hostHeight - margin * 2);
      var ratio = workspaceAspectRatio();
      var cropWidth = availableWidth;
      var cropHeight = cropWidth / ratio;
      if (cropHeight > availableHeight) {
        cropHeight = availableHeight;
        cropWidth = cropHeight * ratio;
      }
      var cropLeft = (hostWidth - cropWidth) / 2;
      var cropTop = (hostHeight - cropHeight) / 2;
      cropper.setCropBoxData({
        left: cropLeft,
        top: cropTop,
        width: cropWidth,
        height: cropHeight
      });
      var imageRatio = imageData.naturalWidth / imageData.naturalHeight;
      var cropRatio = cropWidth / cropHeight;
      var canvasWidth;
      var canvasHeight;
      if (cropRatio > imageRatio) {
        canvasWidth = cropWidth;
        canvasHeight = canvasWidth / imageRatio;
        movementAxis = 'vertical';
      } else {
        canvasHeight = cropHeight;
        canvasWidth = canvasHeight * imageRatio;
        movementAxis = 'horizontal';
      }
      lockedCanvasLeft = cropLeft + (cropWidth - canvasWidth) / 2;
      lockedCanvasTop = cropTop + (cropHeight - canvasHeight) / 2;
      cropper.setCanvasData({
        left: lockedCanvasLeft,
        top: lockedCanvasTop,
        width: canvasWidth,
        height: canvasHeight
      });
      prepareCanvasCropInteraction();
    }

    function captureCropState() {
      if (!cropper) return;
      state.savedCrop = {
        ratio: workspaceAspectRatio(),
        data: cropper.getData(true)
      };
      syncVisualizerButton();
    }

    function changeAspectRatioPreservingCentre() {
      if (!cropper || !isValidSize()) return;
      var imageData = cropper.getImageData();
      var previous = cropper.getData(true);
      var centreX = imageData.naturalWidth ? (previous.x + previous.width / 2) / imageData.naturalWidth : 0.5;
      var centreY = imageData.naturalHeight ? (previous.y + previous.height / 2) / imageData.naturalHeight : 0.5;
      cropper.setAspectRatio(state.widthCm / state.heightCm);
      fitWorkspaceGeometry();
      var next = cropper.getData(true);
      cropper.setData({
        x: centreX * imageData.naturalWidth - next.width / 2,
        y: centreY * imageData.naturalHeight - next.height / 2
      });
      captureCropState();
      updateGuides();
    }

    function initCropper() {
      if (!image || !wallCanvas || !canvasCropBox) return;
      if (cropper) cropper.destroy();
      cropper = null;
      function ready() {
        cropper = createCanvasCropper();
        fitWorkspaceGeometry();
        var savedRatioMatches = state.savedCrop && Math.abs(state.savedCrop.ratio - workspaceAspectRatio()) < 0.0001;
        if (savedRatioMatches) cropper.setData({ x: state.savedCrop.data.x, y: state.savedCrop.data.y });
        else focusOnFocalPoint();
        cropper.scaleX(state.mirrored ? -1 : 1);
        prepareCanvasCropInteraction();
        captureCropState();
        updateGuides();
        updatePrice();
      }
      if (image.complete && image.naturalWidth) ready();
      else image.addEventListener('load', ready, { once: true });
    }

    function openWorkspace() {
      readMeasurements();
      if (!state.sourceReady) {
        window.alert(uploadRequiredMessage);
        if (uploadInput) uploadInput.focus();
        return;
      }
      state.pageScroll = window.scrollY;
      workspace.hidden = false;
      root.classList.add('is-crop-workspace');
      document.body.classList.add('ever-crop-open');
      window.scrollTo(0, 0);
      if (dragHint) dragHint.hidden = false;
      var imageActions = root.querySelector('[data-image-actions]');
      if (imageActions) imageActions.hidden = false;
      requestAnimationFrame(function () {
        initCropper();
        root.scrollTop = 0;
      });
    }

    function closeWorkspace() {
      captureCropState();
      var cropHost = root.querySelector('.croper_main_image');
      var imageActions = root.querySelector('[data-image-actions]');
      if (cropHost) cropHost.classList.remove('is-dragging-artwork');
      if (imageActions) imageActions.hidden = true;
      canvasDrag = null;
      if (cropper) {
        cropper.destroy();
        cropper = null;
      }
      root.classList.remove('is-crop-workspace');
      document.body.classList.remove('ever-crop-open');
      workspace.hidden = true;
      updatePrice();
      window.scrollTo(0, state.pageScroll);
    }

    function setTool(button) {
      var tool = button.getAttribute('data-tool');
      var active = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.classList.toggle('is-active', active);
      if (tool === 'rulers') overlay.classList.toggle('is-rulers-visible', active);
      if (tool === 'panels') overlay.classList.toggle('is-panels-visible', active);
      if (tool === 'person') overlay.classList.toggle('is-person-visible', active);
    }

    function toggleMirror(button) {
      state.mirrored = !state.mirrored;
      button.setAttribute('aria-pressed', state.mirrored ? 'true' : 'false');
      button.classList.toggle('is-active', state.mirrored);
      if (cropper) {
        cropper.scaleX(state.mirrored ? -1 : 1);
        captureCropState();
      }
    }

    function toggleGrayscale(button) {
      state.grayscale = !state.grayscale;
      button.setAttribute('aria-pressed', state.grayscale ? 'true' : 'false');
      button.classList.toggle('is-active', state.grayscale);
      root.classList.toggle('is-grayscale-preview', state.grayscale);
      if (cropper) cropper.render();
      syncVisualizerButton();
    }

    function exportDimensions() {
      var data = cropper.getData(true);
      var maxEdge = 5760;
      var maxPixels = 16000000;
      var scale = Math.min(
        1,
        maxEdge / Math.max(1, data.width),
        maxEdge / Math.max(1, data.height),
        Math.sqrt(maxPixels / Math.max(1, data.width * data.height))
      );
      return {
        width: Math.max(1, Math.round(data.width * scale)),
        height: Math.max(1, Math.round(data.height * scale))
      };
    }

    function croppedCanvas() {
      var output = exportDimensions();
      var canvas = cropper.getCroppedCanvas({
        width: output.width,
        height: output.height,
        fillColor: '#ffffff',
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      });
      if (!state.grayscale) return canvas;
      var filtered = document.createElement('canvas');
      filtered.width = canvas.width;
      filtered.height = canvas.height;
      var context = filtered.getContext('2d');
      context.filter = 'grayscale(1)';
      context.drawImage(canvas, 0, 0);
      return filtered;
    }

    function canvasToBlob(canvas) {
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          if (blob) resolve(blob);
          else reject(new Error(uploadFailedMessage));
        }, 'image/jpeg', 0.94);
      });
    }

    function cropSnapshot() {
      var data = cropper.getData(true);
      var imageData = cropper.getImageData();
      var output = exportDimensions();
      var details = panelDetails();
      return {
        version: 2,
        wall: { widthCm: rounded(state.widthCm, 2), heightCm: rounded(state.heightCm, 2) },
        source: { width: imageData.naturalWidth, height: imageData.naturalHeight, name: uploadedFile ? uploadedFile.name : '' },
        crop: {
          x: rounded(data.x, 2),
          y: rounded(data.y, 2),
          width: rounded(data.width, 2),
          height: rounded(data.height, 2),
          scaleX: state.mirrored ? -1 : 1,
          grayscale: state.grayscale
        },
        output: output,
        panels: { count: details.count, maximumWidthCm: 50, finalWidthCm: details.lastWidth }
      };
    }

    async function addToCart() {
      readMeasurements();
      if (!cropper || !isValidSize()) {
        window.alert(invalidSizeMessage);
        return;
      }
      var variant = selectedVariant();
      if (!variant) return;
      addButton.disabled = true;
      try {
        var snapshot = cropSnapshot();
        var imageBlob = await canvasToBlob(croppedCanvas());
        var sizeText = measurementText();
        var timestamp = Date.now();
        var filename = productHandle + '-' + Math.round(state.widthCm) + 'x' + Math.round(state.heightCm) + 'cm-' + timestamp + '.jpg';
        root.querySelector('#SizeCustom').value = sizeText.width + ' × ' + sizeText.height;
        if (cropDataInput) cropDataInput.value = JSON.stringify(snapshot);
        root.querySelector('.VariantHidden').value = variant.getAttribute('data-id');
        root.querySelector('.product-form__input--quantity').value = state.quantity;
        var formData = new FormData(form);
        formData.delete('properties[Cropped Image]');
        formData.append('properties[Cropped Image]', imageBlob, filename);
        var routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        var response = await fetch(routesRoot + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        var data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || uploadFailedMessage);
        window.location.assign(routesRoot + 'cart');
      } catch (error) {
        console.error(error);
        window.alert(error.message || uploadFailedMessage);
        addButton.disabled = false;
      }
    }

    root.querySelectorAll('.inputsize').forEach(function (input) {
      input.addEventListener('input', function () {
        var hadValidSize = isValidSize();
        if ((input.classList.contains('inf_width') || input.classList.contains('inf_height')) && parseFloat(input.value) > 11) input.value = 11;
        readMeasurements();
        updatePrice();
        if (!cropper) return;
        if (isValidSize()) changeAspectRatioPreservingCentre();
        else if (hadValidSize) {
          state.savedCrop = null;
          fitWorkspaceGeometry();
          focusOnFocalPoint();
          captureCropState();
          updateGuides();
        } else updateGuides();
      });
    });

    function chooseUnit(unit) {
      readMeasurements();
      populateUnitFromCentimetres(unit);
      setUnit(unit);
      if (unitMenu) unitMenu.hidden = true;
      if (unitToggle) unitToggle.setAttribute('aria-expanded', 'false');
      if (cropper && isValidSize()) changeAspectRatioPreservingCentre();
    }

    if (unitSelector) unitSelector.addEventListener('change', function () { chooseUnit(unitSelector.value); });
    if (unitToggle && unitMenu) {
      unitToggle.addEventListener('click', function () {
        var opening = unitMenu.hidden;
        unitMenu.hidden = !opening;
        unitToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      });
      root.querySelectorAll('[data-unit-option]').forEach(function (option) {
        option.addEventListener('click', function () { chooseUnit(option.getAttribute('data-unit-option')); });
      });
    }

    root.querySelectorAll('.action-set').forEach(function (button) {
      button.addEventListener('click', function () {
        root.querySelectorAll('.action-set').forEach(function (item) {
          item.classList.remove('selected-variant');
          item.setAttribute('aria-checked', 'false');
        });
        button.classList.add('selected-variant');
        button.setAttribute('aria-checked', 'true');
        root.querySelector('.VariantHidden').value = button.getAttribute('data-id');
        updatePrice();
      });
    });

    root.querySelectorAll('[data-tool]').forEach(function (button) {
      button.addEventListener('click', function () { setTool(button); });
    });

    var mirrorButton = root.querySelector('[data-mirror-toggle]');
    var grayscaleButton = root.querySelector('[data-grayscale-toggle]');
    if (previewButton) previewButton.addEventListener('click', openWorkspace);
    if (closeButton) closeButton.addEventListener('click', closeWorkspace);
    if (mirrorButton) mirrorButton.addEventListener('click', function () { toggleMirror(mirrorButton); });
    if (grayscaleButton) grayscaleButton.addEventListener('click', function () { toggleGrayscale(grayscaleButton); });
    if (dismissDragHint && dragHint) dismissDragHint.addEventListener('click', function () { dragHint.hidden = true; });
    if (addButton) addButton.addEventListener('click', addToCart);

    if (sourceMode === 'upload' && uploadInput) {
      uploadInput.addEventListener('change', function () {
        var file = uploadInput.files && uploadInput.files[0];
        if (!file || !/^image\/(jpeg|png|webp)$/i.test(file.type)) {
          state.sourceReady = false;
          updatePrice();
          if (file) window.alert('Please choose a JPG, PNG or WebP image.');
          return;
        }
        uploadedFile = file;
        state.sourceReady = false;
        state.savedCrop = null;
        if (cropper) {
          cropper.destroy();
          cropper = null;
        }
        if (uploadedObjectUrl) URL.revokeObjectURL(uploadedObjectUrl);
        uploadedObjectUrl = URL.createObjectURL(file);
        image.addEventListener('load', function () {
          state.sourceReady = Boolean(image.naturalWidth && image.naturalHeight);
          if (uploadPreview) uploadPreview.src = uploadedObjectUrl;
          if (uploadPreviewFrame) uploadPreviewFrame.classList.add('has-upload');
          if (uploadPreviewCopy) uploadPreviewCopy.hidden = true;
          updatePrice();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          var firstSizeInput = root.querySelector('.cm_width');
          if (firstSizeInput) window.setTimeout(function () { firstSizeInput.focus({ preventScroll: true }); }, 450);
        }, { once: true });
        image.addEventListener('error', function () {
          state.sourceReady = false;
          updatePrice();
          window.alert(uploadFailedMessage);
        }, { once: true });
        image.src = uploadedObjectUrl;
        updatePrice();
      });
    }

    var orderCommentToggle = root.querySelector('[data-order-comment-toggle]');
    var orderComment = root.querySelector('[data-order-comment]');
    if (orderCommentToggle && orderComment) {
      orderCommentToggle.addEventListener('click', function () {
        var opening = orderComment.hidden;
        orderComment.hidden = !opening;
        orderCommentToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening) orderComment.focus();
      });
    }

    var infoButton = root.querySelector('.messure_info');
    var infoText = root.querySelector('.info_first');
    if (infoButton && infoText) {
      infoButton.addEventListener('click', function () {
        var expanded = infoButton.getAttribute('aria-expanded') === 'true';
        infoButton.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        infoText.hidden = expanded;
      });
    }

    window.addEventListener('resize', function () {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(function () {
        resizeFrame = 0;
        if (cropper) fitWorkspaceGeometry();
        updateGuides();
      });
    });
    document.addEventListener('click', function (event) {
      if (unitPicker && unitMenu && !unitPicker.contains(event.target)) {
        unitMenu.hidden = true;
        if (unitToggle) unitToggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && unitMenu && !unitMenu.hidden) {
        unitMenu.hidden = true;
        if (unitToggle) unitToggle.setAttribute('aria-expanded', 'false');
        return;
      }
      if (event.key === 'Escape' && root.classList.contains('is-crop-workspace')) closeWorkspace();
    });
    readMeasurements();
    updatePrice();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initWallpaperProduct);
  else initWallpaperProduct();
}());
